function getRouterRootFromOneOptions(options) {
  var _options_router;
  return (options === null || options === void 0 ? void 0 : (_options_router = options.router) === null || _options_router === void 0 ? void 0 : _options_router.root) || process.env.ONE_ROUTER_ROOT || "app";
}
export {
  getRouterRootFromOneOptions
};
//# sourceMappingURL=getRouterRootFromOneOptions.js.map
